<template>
    <rent-select-filter  :class="{error: error.landlord}" class="select-scroll select-landlord  biz" refName="landlord" :selectMsg="landlord.selectWord" @getId="getSelectId" bgColor="#fff" :setDefault="false">
        <div class="select-filter">
            <img class="search" src="@/assets/img/icon/search_black.svg" alt="">
            <input v-model="landlord.filterWord" placeholder="搜尋房東" type="text">
            <span v-if="landlord.filterWord" @click="setLandlord" class="add-landlord">建立房東</span>
        </div>
        <ul>
            <li v-for="(item, index) in filterByWord" :key="index" :data-id="item.id" @click="seletedWord(index)">
                {{setLandlordWording(item, true)}}
                <!-- {{item.name}}．{{item.phone?item.phone:'未輸入電話'}} -->
                <!-- <radio :val="item.id" v-model="landlord.value" :isPropChecked="landlord.value == item.id" :isLeftMsg="true" :msg="setLandlordWording(item, true)"></radio> -->
            </li>
        </ul>
    </rent-select-filter>
</template>
<script>
import RentSelectFilter from '@/components/bussiness/widges/tools/RentSelectFilter.vue';
import Radio from '@/components/bussiness/widges/input/radio.vue';
import { mapGetters } from 'vuex'

import { 
    apiBizSetLandlord,
    apiBizInsertLandlord
} from "@/apis/api.js"; 
export default {
    data () {
        return {
            landlord:{
                filterWord: null,
                value: null,
                selectWord: this.msg
            },
            error: {
                landlord: null
            },
        }
    },
    props: {
        msg: null,
        isPhone: {
            type: Boolean,
            default: true
        }
    },
    mounted () {
        // this.getLandlordList()
    },
    watch: {
        msg: function (val) {
            if(val){
                // this.selectColor = '#676362'
                this.landlord.selectWord = val
            }
        },
    },
    methods: {
        seletedWord: function (index) {
            // this.landlord.selectWord = this.setLandlordWording(this.filterByWord[index], false)
            this.$emit('getLandlordId', this.filterByWord[index].id)
        },
        setLandlordWording: function (item, isPhone){
            let name = item.name
            let phone
            if(item.mobilePhone){
                phone = item.mobilePhone
            }else if(item.telephone){
                phone = item.telephone
            }else{
                phone = '未輸入電話'
            }

            if(isPhone){
                console.log(isPhone)
                return name+'．'+phone
            }else{
                return name
            }
        },
        // getLandlordList: function () {
        //     apiBizGetLandlordList()
        //     .then( res => {
        //         console.log(res)
        //         if(res.data.status = 'SUCCESS'){
        //             this.landlordList = res.data.result
        //         }
        //     })
        //     .catch( err => {
        //         console.log(err)
        //     })
        // },
        setLandlord: function () {
            
            let data = {
                name: this.landlord.filterWord
            }
            
            apiBizInsertLandlord(data)
            .then( res => {
                console.log(res)
                if(res.data.status = 'SUCCESS'){
                    this.$store.dispatch('getBizLandlordList')
                    this.$store.dispatch('setAlarmStatus', {status: true,closeBtn: false,title: '成功建立房東',type: 'success'})
                }
            })
            .catch( err => {
                console.log(err)
            })
        },
        getSelectId: function (value) {
            // console.log(value)
            let targetId = parseInt(event.target.dataset.id)
            if( value.ref == 'landlord' ){
                this.insertHouse.houseType = targetId
                this.roomPattern = true
                this.housePattern = true
            }
        },
    },
    computed: {
        filterByWord: function () {
            return this.landlordList.filter((item) => {
                if( this.landlord.filterWord ){
                    console.log(this.landlord.filterWord)
                    if( item.name.includes( this.landlord.filterWord ) || item.mobilePhone !== null && item.mobilePhone.includes( this.landlord.filterWord )  || item.telephone !== null && item.telephone.includes( this.landlord.filterWord ) ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            landlordList: 'GET_LANDLORD_LIST',
        })
    },
    components: {
        RentSelectFilter,
        Radio
    }
}
</script>
<style lang="scss">
    .biz-rent-select-filter{
        background: #fff;
        &.select-landlord{
            .select-filter{
                .add-landlord{
                    color: #3942b5;
                    width: 73px;
                }
            }
            ul{
                li{
                    // padding: 0;
                    // .input-radio{
                    //     padding: 12px 16px;
                    //     display: flex;
                    //     align-items: center;
                    //     justify-content: space-between;
                    // }
                    &:first-child{
                        padding-top: 52px;
                    }
                }
            }
        }   
    }
    
</style>


// WEBPACK FOOTER //
// src/components/bussiness/mgtCategory/houseMgt/addHouse/selectLandlord.vue